
export const types = {
    generalGetCategories: '[general] Get categories',
    generalGetServices: '[general] Get services',
    generalGetUnidadMedida: '[general] Get unidad medida',
    generalAddNewServices: '[general] add new services',
    generalAddNewCategories: '[general] add new categories',

    generalAddNewServicesBuy: '[general] add new services buy',
    generalAddNewCategoriesBuy: '[general] add new categories buy',

    generalGetUnits: '[general] get units',
    generalGetExecutives: '[general] get executives',
    generalGetUsuariosTarea: '[general] get usuarios tarea',
    generalGetCurrency: '[general] get currency',
    generalGetCustomers: '[general] get customers',
    generalGetFormasPagos: '[general] get lista formas de pagos',
    generalGetFormasPagosVentas: '[general] get lista formas de pagos ventas',
    generalGetTiposDocumentos: '[general] get lista de documentos',
    generalGetCategoriesGasto: '[general] Get categories gasto',
    generalGetServicesGasto: '[general] Get services gasto',
    ajustesLoadDetail: '[ajustes] load detail',
    getInfoPropietaria: '[ajustes] get info propietaria',

    generalGetListaBancos: '[general] Get lista bancos',
    generalGetListaTiposCuenta: '[general] Get lista tipos cuenta',
    generalGetListaCtasBancarias: '[general] Get lista ctas bancarias',

    generalGetRules: '[general] Get rules',
    generalSetOpenProgress: '[general] Open Progress',

}